const trustItems = [
  {
    icon: "ri-award-line",
    stat: "Est. 1986",
    label: "Decades of Experience",
    desc: "40+ years of specialized legal expertise",
  },
  {
    icon: "ri-user-heart-line",
    stat: "Top 5",
    label: "Nationally Recognized",
    desc: "Best Law Firm 2024 & 2025",
  },
  {
    icon: "ri-shield-check-line",
    stat: "100%",
    label: "Client-Focused",
    desc: "Senior partner on every matter",
  },
  {
    icon: "ri-globe-line",
    stat: "50 States",
    label: "National Reach",
    desc: "Federal health law counsel nationwide",
  },
];

export default function SectionTrustBar() {
  return (
    <section className="bg-[#0D1B30] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0">
          {trustItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 py-4 px-4 lg:px-6 ${
                i < trustItems.length - 1 ? "lg:border-r border-white/10" : ""
              }`}
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-[#C9A961]/15 border border-[#C9A961]/30 flex-shrink-0">
                <i className={`${item.icon} text-[#C9A961] text-lg`} />
              </span>
              <div>
                <div className="text-[#C9A961] font-playfair font-bold text-lg leading-none mb-0.5">
                  {item.stat}
                </div>
                <div className="text-white font-inter font-semibold text-xs leading-snug">
                  {item.label}
                </div>
                <div className="text-slate-400 text-[11px] font-inter mt-0.5">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
